import { Hero } from '../components/home/Hero';
import { Categories } from '../components/home/Categories';
import { WhyChooseUs } from '../components/home/WhyChooseUs';
import { Testimonials } from '../components/home/Testimonials';

export const HomePage = () => {
  return (
    <main data-testid="home-page">
      <Hero />
      <Categories />
      <WhyChooseUs />
      <Testimonials />
    </main>
  );
};

export default HomePage;
